/** Entries for the project settings search box. */
export const trainingSettingsIndex = [
  {
    path: "/training",
    title: "Training",
    keywords: ["train", "model", "compute", "active learning", "predictions", "ml backend", "retrain"],
  },
];
